import { computed } from "vue";

import { datetime } from "@/mixins";

interface MediaItem {
  source?: string;
  created_by_name?: string;
  created_at?: string;
}

const SOURCE_LABELS: Record<string, string> = {
  admin_portal: "Admin Portal",
  tech_app: "Tech App",
  customer_portal: "Customer Portal",
  widget: "Widget"
};

const SOURCE_ICONS: Record<string, string> = {
  admin_portal: "fa-solid fa-desktop",
  tech_app: "fa-solid fa-mobile-screen",
  customer_portal: "fa-solid fa-user",
  widget: "fa-solid fa-puzzle-piece"
};

export function useMediaSource(
  media: () => MediaItem,
  defaultIcon = "fa-regular fa-file"
) {
  const formattedSource = computed(() => {
    const item = media();
    if (!item?.source) return "";

    const sourceLabel = SOURCE_LABELS[item.source] || item.source;

    if (item.created_by_name) {
      return `${item.created_by_name} via ${sourceLabel}`;
    }

    return sourceLabel;
  });

  const sourceIcon = computed(() => {
    const item = media();
    if (!item?.source) return defaultIcon;
    return SOURCE_ICONS[item.source] || defaultIcon;
  });

  const formattedDate = computed(() => {
    const item = media();
    return datetime(item?.created_at);
  });

  return {
    formattedSource,
    sourceIcon,
    formattedDate
  };
}
